<div class="flex flex-justify-between flex-middle">
    <div class="inline-block">
        <span [innerHtml]="coupon || ('Discount' | translate)"></span>
        @if (coupon) {
        <action class="inline-block m-l-1 cursor-pointer"
                [status]="status"
                (click)="remove()">
            <span class="underline">{{'Remove' | translate}}</span>
        </action>
        }
    </div>
    <price class="price"
           [value]="couponValue" />
</div>
